export default {
      id: "icon-arrow-circle-usage",
      viewBox: "0 0 67 67",
      url: "../icon/" + "icons.svg#icon-arrow-circle-usage",
      toString: function () {
        return this.url;
      }
    }